<template>
  <div class="animated fadeIn">
    <div
      class="dashboard-header d-flex justify-content-between align-items-center mb-3"
    >
      <h4 v-if="isMasterUser" class="mb-0">
        Dashboard da {{ company.fantasyName }}
      </h4>
      <span v-else></span>
      <display-mode-toggle
        v-if="canViewCharts"
        v-model="displayMode"
        storage-key="dashboard:displayMode:dsar"
      />
    </div>
    <list-notifications :company="company._id" type="dsar"></list-notifications>

    <!-- Card de Solicitações Atrasadas -->
    <b-row v-if="isMasterUser || isOperationalUser" class="mb-4">
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <overdue-dsar :company-id="company._id"></overdue-dsar>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="canViewCharts">
      <b-col sm="6" lg="4">
        <b-card no-body class="chart-card chart-animation">
          <b-card-body>
            <dsar-per-status
              :company="company._id"
              :style="{ 'max-height': maxHeight }"
            ></dsar-per-status>
          </b-card-body>
        </b-card>
      </b-col>
      <template v-if="company.classification">
        <b-col
          v-if="company.classification.receivingMeans.enabled"
          sm="6"
          lg="4"
        >
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <dsar-per-receiving-means
                :company="company._id"
                :style="{ 'max-height': maxHeight }"
              >
              </dsar-per-receiving-means>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col
          v-if="company.classification.dsarRequirementType.enabled"
          sm="6"
          lg="4"
        >
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <dsar-per-requirement-type
                :company="company._id"
                :style="{ 'max-height': maxHeight }"
              >
              </dsar-per-requirement-type>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col v-if="company.classification.dsarClosure.enabled" sm="6" lg="4">
          <b-card no-body class="chart-card chart-animation">
            <b-card-body>
              <dsar-per-closure
                :company="company._id"
                :style="{ 'max-height': maxHeight }"
              >
              </dsar-per-closure>
            </b-card-body>
          </b-card>
        </b-col>
      </template>
      <b-col sm="6" lg="4">
        <b-card no-body class="chart-card chart-animation">
          <b-card-body>
            <dsar-time-box-plot :company="company._id"></dsar-time-box-plot>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import ListNotifications from "../list-notifications";
import DsarPerStatus from "../charts/dsar/DsarPerStatus";
import DsarTimeBoxPlot from "../charts/dsar/DsarTimeBoxPlot";
import DsarPerReceivingMeans from "../charts/dsar/DsarPerReceivingMeans";
import DsarPerRequirementType from "../charts/dsar/DsarPerRequirementType";
import DsarPerClosure from "../charts/dsar/DsarPerClosure";
import OverdueDsar from "../charts/dsar/OverdueDsar";
import DisplayModeToggle from "../DisplayModeToggle.vue";

const STORAGE_KEY = "dashboard:displayMode:dsar";

export default {
  name: "DSARDashboard",
  components: {
    DsarPerClosure,
    DsarPerRequirementType,
    DsarPerReceivingMeans,
    ListNotifications,
    DsarPerStatus,
    DsarTimeBoxPlot,
    OverdueDsar,
    DisplayModeToggle,
  },
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  provide() {
    return {
      dashboardDisplayMode: this.dashboardDisplayMode,
    };
  },
  data() {
    const stored = localStorage.getItem(STORAGE_KEY);
    const initialMode = stored === "percent" ? "percent" : "absolute";
    return {
      maxHeight: "100%",
      displayMode: initialMode,
      dashboardDisplayMode: Vue.observable({ mode: initialMode }),
    };
  },
  watch: {
    displayMode(newMode) {
      this.dashboardDisplayMode.mode = newMode;
    },
  },
  computed: {
    ...mapGetters(["profile", "permissions"]),
    isMasterUser() {
      return (
        this.profile.role === "root" || this.profile.role === "company-root"
      );
    },
    isOperationalUser() {
      return typeof this.profile.role === "number";
    },
    canViewCharts() {
      if (parseInt(this.profile.role) === this.profile.role) {
        return this.permissions.dsar && this.permissions.dsar.read;
      }
      return true;
    },
  },
};
</script>
